import { createStore } from 'vuex'
import user from './modules/user'

// 创建插件以监听状态变化
const stateUpdatePlugin = (store) => {
  // 订阅状态变化
  store.subscribe((mutation, state) => {
    // 当用户信息或登录状态发生变化时，强制更新
    if (mutation.type.startsWith('user/')) {
      // 触发视图更新
      store.dispatch('forceUpdate')
    }
  })
}

export default createStore({
  modules: {
    user
  },
  state: {
    updateTrigger: 0
  },
  mutations: {
    triggerUpdate(state) {
      state.updateTrigger++
    }
  },
  actions: {
    forceUpdate({ commit }) {
      commit('triggerUpdate')
    }
  },
  plugins: [stateUpdatePlugin]
})